import { _Environment } from "./core";
import { useWorkFlow } from "../components/contexts/workflow";
var getCurrentDate = function getCurrentDate() {
  var date = new Date();
  date.setHours(0, 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
};
var useAnalytics = function useAnalytics(collector) {
  var localeCollector = collector;
  var diagId = localeCollector.diagId;
  var api = _Environment.get('api_url');
  var setCollector = function setCollector(currCollector) {
    localeCollector = currCollector;
  };
  var send = function send(url, jsonData) {
    navigator.sendBeacon(api + url, JSON.stringify(jsonData));
  };
  var initDiagnostic = function initDiagnostic(diagId) {
    var analyzer = {
      timestamp: getCurrentDate(),
      // ip: data.ip,
      diag: diagId,
      events: []
    };
    send('/analytics/diagnostics/init', analyzer);
  };
  var sendQuestion = function sendQuestion() {
    var _question$id, _question$alias, _question$previousQue;
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'start';
    var questionToPatch = arguments.length > 1 ? arguments[1] : undefined;
    var timer = new Date().getTime() - collector.question_time_start;
    var currentQuestion = collector.currentQuestion;
    var question = questionToPatch !== null && questionToPatch !== void 0 ? questionToPatch : currentQuestion;
    var questionAnalyzer = {
      questionId: (_question$id = question.id) !== null && _question$id !== void 0 ? _question$id : 'NA',
      questionAlias: (_question$alias = question.alias) !== null && _question$alias !== void 0 ? _question$alias : 'NA',
      previousQuestionId: (_question$previousQue = question.previousQuestionId) !== null && _question$previousQue !== void 0 ? _question$previousQue : null,
      diag: diagId,
      today: getCurrentDate(),
      timer: parseInt(timer / 1000),
      type: type
    };
    send('/analytics/diagnostics/patch_question', questionAnalyzer);
  };
  var sendEnd = function sendEnd() {
    var analyzer = {
      timestamp: getCurrentDate(),
      duration: (new Date().getTime() - collector.start_date.getTime()) / 1000,
      diag: diagId
    };
    send('/analytics/diagnostics/end', analyzer);
  };
  var sendEvent = function sendEvent(type) {
    var event = {
      timestamp: getCurrentDate(),
      diag: diagId,
      type: type
    };
    send('/analytics/diagnostics/add_event', event);
  };
  return {
    post: {
      init: initDiagnostic,
      question: sendQuestion,
      end: sendEnd,
      event: sendEvent
    },
    set: {
      collector: setCollector
    }
  };
};
export default useAnalytics;